import { projectsApi } from 'api'

export interface SignedUrlBody {
  name: string
  type: string
  extension: string
  mimeType: string
  metaData: string
  originalName: string
  description: string
  uploadType: string
  size: number
  currentIndex?: number
}

export interface SignedUrlResponse {
  fileObject: any
  filename: string
  signedUrlObj: any
}

export const postSignedUrl = (data: SignedUrlBody) => {
  const body = {
    ...data,
  }
  return projectsApi.post<SignedUrlResponse>('/files/signed-url', body)
}
